import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "documentsMenu";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const TAB = {
    DOCUMENTS: "documents",
    OBJECTS: "objects",
    NAVIGATION: "navigation",
    METHODS: "methods",
    SCRIPTS: "scripts",
    TASKS: "tasks"
};
export const CONTENT_MODE_TAB = {
    FOUND: "found",
    UPLOAD: "upload"
};
export const NEW_SCRIPT = {
    Id: 0,
    Name: "",
    Methods: [],
    Created: 0
};
export const MAX_COUNT_OF_TRANSFORMS_WITHOUT_CONFIRMATION = 10;
export const requiredFields = ["Name", "Methods"];
export const MASTER_KEY_PREFIX = "master";
export const GROUP_KEY_PREFIX = "group";
export const CHILD_KEY_PREFIX = "child";
export const EMPTY_FOLDER_KEY = "empty";
export const FOLDER_KEY_REFIX = "userContentFolder";
export const FILE_KEY_REFIX = "userContentFile";
